import React, { useState, useCallback, useEffect } from 'react'
import { useField } from 'formik'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import withOutClick from '../../../login/components/input/out-side-lick'

const email_suffixs = ["gmail.com", "hotmail.com", "yahoo.com", "outlook.com", "icloud.com", "aol.com", "mail.com", "live.com", "wp.pl", "gmx.net"]

const Picker = props => {
    useStyles(classes)
    const { email, onSelect } = props
    const emailPrefix = email?.split('@')?.[0] || ''
    const emailSuffix = email?.split('@')?.[1] || ''
    
    const filteredSuffixs = email_suffixs.filter(s => s.startsWith(emailSuffix))

    return filteredSuffixs?.length > 0 ? <div className={classes.PickerContainer}>
        <ul className={classes.PickerList}>
            {
                filteredSuffixs.map(suffix => <li key={suffix} onClick={e => onSelect(`${emailPrefix}@${suffix}`)}>
                    {`${emailPrefix}@${suffix}`}
                </li>)
            }
        </ul>
    </div>: <></>
}


export default withOutClick(({ label, open, ...props }) => {
    useStyles(classes)

    const [field, meta, helpers] = useField(props)
    const [filled, setFilled] = useState(!!field?.value)
    const [focused, setFocused] = useState(false)
    const [showPicker, setShowPicker] = useState(false)

    useEffect(() => {
        setShowPicker(false)
    }, [open])

    useEffect(() => {
        setFilled(!!field?.value || focused || props.placeholder)
    }, [field.value, focused, props.placeholder])

    const focusHandle = useCallback(e => {
        setFocused(true)
        setShowPicker(true)
    }, [])

    const blurHandle = useCallback(e => {
        field.onBlur(e)
        setFocused(false)
    }, [])

    const selectHandle = email => {
        helpers.setValue(email)
        setShowPicker(false)
    }

    return <div className={classes.EmailContainer}>
        <div className={`${classes.Container} ${meta.touched && meta.error ? classes.Errored : ''}`}>
            <label className={`${filled ? classes.Focused : ''}`}>
                {label}
            </label>
            <div className={`${classes.InputWrapper} ${focused ? classes.Focused : ''}`}>
                <input type="text" aria-autocomplete='off' className={classes.Input} {...field} {...props} autocomplete='new-password' onFocus={focusHandle} onBlur={blurHandle} />
            </div>
            {meta.touched && meta.error && <div className={classes.Error}>{meta.error}</div>}
        </div>
        {
            showPicker && field.value && <Picker email={field.value} onSelect={selectHandle} />
        }

    </div>
})